import { IConnectionService, Ulid } from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { getBlobType, getPdfThumbnails } from "../utils";
import { ReceiptAttachment } from "./interfaces";

export const getAttachment = async (
    con: IConnectionService,
    company: string,
    receipt: Readonly<Ulid>,
    _id: Readonly<Ulid>,
) => {
    const attachment = await con.expense.receipt.getAttachment({
        id: _id,
        company,
        receipt,
    });
    const type = await getBlobType(attachment.url);
    const thumbnails = signal(
        type !== "application/pdf" ? [attachment.url] : [],
    );
    const thumbnailsLoaded = signal(type !== "application/pdf");

    return Object.assign(attachment, {
        id: _id.toString(),
        type,
        thumbnails,
        thumbnailsLoaded,
    });
};

export const loadThumbnails = async (attachment: ReceiptAttachment) => {
    if (attachment.thumbnailsLoaded.peek()) {
        return;
    }

    attachment.thumbnails.value = await getPdfThumbnails(attachment.url);
    attachment.thumbnailsLoaded.value = true;
};
